export default __webpack_public_path__ + "static/media/Background_00181.5665daa7.png";